import { ExcelExportParams } from "@ag-grid-community/core";
import { AgGridReact } from "@ag-grid-community/react";
import {
  dataTableContextFromAgGrid,
  getDataTableAgHeaderComponentParams,
} from "shared/components/table/data/DataTableUtils";
import { COLUMN_ID_ACTIONS } from "shared/components/table/data/internal/DataTableConstants";
import {
  DEFAULT_EXPORT_TITLE,
  maybernTableExcelExportParams,
} from "shared/components/table/maybern/MaybernTableExport";

export const dataTableParamsForExcelExport = (
  agGrid: AgGridReact,
  title: string = DEFAULT_EXPORT_TITLE,
): ExcelExportParams => {
  const context = dataTableContextFromAgGrid(agGrid);
  const columnKeys = agGrid.api
    .getColumns()
    ?.filter((agColumn) => {
      if (agColumn.getId() === COLUMN_ID_ACTIONS) {
        return false;
      }
      if (agColumn.getColDef().hide) {
        return false;
      }
      const { column } = getDataTableAgHeaderComponentParams(agColumn);
      return (
        (agColumn.isVisible() || agColumn.isRowGroupActive()) &&
        column.is_exported
      );
    })
    .map((c) => c.getColId());
  return {
    ...maybernTableExcelExportParams(title),
    columnKeys,
    suppressRowOutline: Boolean(context?.isClientRowAggregation),
  };
};
